import React from 'react';

import LineChart from '@features/crm/brands/components/LineChart';
import CustomCalender from '@features/crm/components/CustomCalender';

const BrandOverview = () => {
	return (
		<div className="tab-contents overview-contents">
			<div className="d-flex justify-content-between align-items-center">
				<p className="regular-18 gray_dark_01 weight-500">Orders Analytics</p>
				<div className="order-indicator">
					<ul className="d-flex">
						<li className="regular-12 gray_dark_01 mr-4">
							<span className="indicator red"></span>No of Order
						</li>
						<li className="regular-12 gray_dark_01 mr-4">
							<span className="indicator blue"></span>Total Style
						</li>
						<li className="regular-12 gray_dark_01">
							<span className="indicator yellow"></span>Nitex Style
						</li>
					</ul>
				</div>
				<CustomCalender />
			</div>
			<div className="graph">
				<LineChart />
			</div>
		</div>
	);
};

export default BrandOverview;
